(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blade-card-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__bladeCards) return;
    window.__bladeCards = true;

    const KEY = 'blade.wishlist';
    const read = () => {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; }
    };
    const write = (list) => {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('blade:wishlist'));
    };

    const text = (card, sel) => card.querySelector(sel)?.textContent.trim() || '';
    const dataOf = (card) => ({
      id: card.dataset.handle,
      href: card.dataset.url,
      img: card.dataset.img,
      name: text(card, '.b-card__name'),
      brand: text(card, '.b-card__brand'),
      price: text(card, '.b-card__now'),
      was: text(card, '.b-card__was'),
    });

    const paint = (btn, on) => {
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', String(on));
    };
    const sync = () => {
      const ids = new Set(read().map((x) => x.id));
      document.querySelectorAll('.b-card').forEach((card) => {
        const btn = card.querySelector('.b-card__wl');
        if (btn) paint(btn, ids.has(card.dataset.handle));
      });
    };

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.b-card__wl');
      if (!btn) return;
      e.preventDefault();
      const card = btn.closest('.b-card');
      const list = read();
      const id = card.dataset.handle;
      write(list.some((x) => x.id === id) ? list.filter((x) => x.id !== id) : [...list, dataOf(card)]);
      sync();
    });

    /* the add button's tick, shown for as long as the HTML showed it */
    document.addEventListener('blade:cart-added', (e) => {
      const btn = e.target.closest?.('.b-card__add');
      if (!btn) return;
      btn.classList.add('is-added');
      clearTimeout(btn.__bladeTick);
      btn.__bladeTick = setTimeout(() => btn.classList.remove('is-added'), 1400);
    });

    window.addEventListener('storage', (e) => { if (e.key === KEY) sync(); });
    document.addEventListener('blade:wishlist', sync);
    document.addEventListener('blade:cards-rendered', sync);
    document.addEventListener('DOMContentLoaded', sync);
    document.addEventListener('shopify:section:load', sync);
    if (document.readyState !== 'loading') sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blade-cart-drawer"] && !Shopify.designMode) return;
  try {
    /* Blade's one way into the cart. window.bladeCartAdd(variantId, quantity) posts
     to /cart/add.js with the drawer's section id and dispatches Horizon's
     CartLinesUpdateEvent, so the drawer and count re-render (and the drawer
     auto-opens when the theme setting says so). Buttons with data-blade-add
     (product cards) or data-blade-addon (drawer add-ons) add one unit. */
  (() => {
    if (window.bladeCartAdd) return;

    window.bladeCartAdd = async (variantId, quantity = 1) => {
      const sectionId = document.querySelector('cart-items-component[data-section-id]')?.dataset.sectionId;
      const root = window.Shopify?.routes?.root || '/';
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ merchandiseId: String(variantId), quantity }],
        promise: deferred.promise,
      }));
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity }], sections: sectionId }),
      });
      const json = await res.json();
      if (!res.ok) {
        const error = new Error(json.description || json.message || 'Could not add to cart');
        deferred.reject(error);
        throw error;
      }
      const cart = await (await fetch(`${root}cart.js`)).json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'blade-add', itemCount: quantity, sections: json.sections, didError: false },
      });
      return json;
    };

    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-blade-add], [data-blade-addon]');
      if (!btn || btn.disabled) return;
      btn.disabled = true;
      try {
        await window.bladeCartAdd(btn.dataset.bladeAdd || btn.dataset.bladeAddon, 1);
        btn.dispatchEvent(new CustomEvent('blade:cart-added', { bubbles: true }));
      } catch (err) {
        console.warn('[blade-cart] add failed:', err);
      } finally {
        btn.disabled = false;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blade-vehicle-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.BladeVehicle) return;

    const KEY = 'blade.vehicle';
    const norm = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const esc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    let catalogue = null;
    const loadCatalogue = () => {
      if (!catalogue) {
        try { catalogue = JSON.parse(document.querySelector('[data-vehicle-catalogue]')?.textContent || 'null'); } catch (e) { catalogue = null; }
      }
      return catalogue || {};
    };
    const makes = () => Object.keys(loadCatalogue());

    const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } };
    const write = (v) => {
      try { v ? localStorage.setItem(KEY, JSON.stringify(v)) : localStorage.removeItem(KEY); } catch (e) {}
      document.dispatchEvent(new CustomEvent('blade:vehicle'));
    };
    const label = (v) => (v ? [v.year, v.make, v.model].filter(Boolean).join(' ') : '');

    /* "Toyota Vios 2014-2023" → { make, model, from, to } */
    const parseEntry = (entry) => {
      let text = String(entry || '').trim();
      if (!text) return null;
      let from = null; let to = null;
      const range = text.match(/(\d{4})\s*(?:-|–|to)\s*(\d{4}|present|up|now)?\s*$/i);
      const single = !range && text.match(/\b(\d{4})\s*$/);
      if (range) { from = +range[1]; to = /^\d{4}$/.test(range[2] || '') ? +range[2] : (range[2] ? 9999 : +range[1]); text = text.slice(0, range.index).trim(); }
      else if (single) { from = +single[1]; to = +single[1]; text = text.slice(0, single.index).trim(); }
      const known = makes().sort((a, b) => b.length - a.length).find((m) => norm(text).startsWith(norm(m)));
      let make; let model;
      if (known) { make = known; model = text.slice(known.length).trim(); }
      else { [make, ...model] = text.split(/\s+/); model = model.join(' '); }
      return { make, model, from, to };
    };

    /* true = fits, false = does not fit, null = no data.
       Most of the catalogue is universal, so a product with no fitment list
       counts as fitting unless the theme setting says to stay quiet. */
    const fits = (entries, universal, v) => {
      if (!v) return null;
      /* Blade sells its range as universal fit, so every product answers yes
         unless the theme setting is turned off */
      if (window.BladeVehicle?.allUniversal) return true;
      if (universal) return true;
      const list = (Array.isArray(entries) ? entries : String(entries || '').split(';')).map(parseEntry).filter(Boolean);
      if (!list.length) return window.BladeVehicle?.assumeUniversal ? true : null;
      const year = +v.year;
      return list.some((e) => {
        if (norm(e.make) !== norm(v.make)) return false;
        if (e.model) {
          const a = norm(e.model); const b = norm(v.model);
          if (!(a === b || a.startsWith(b) || b.startsWith(a))) return false;
        }
        if (e.from && year && (year < e.from || year > e.to)) return false;
        return true;
      });
    };

    const YES = '<svg width="12" height="12" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2.6" aria-hidden="true"><path d="M2 7.4 5.4 11 12 3.4"/></svg>';
    const NO = '<svg width="12" height="12" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2.6" aria-hidden="true"><path d="M3 3l8 8M11 3l-8 8"/></svg>';

    /* cards inside [data-fitment] grids get a "fits / does not fit" line */
    const paintCards = (root = document) => {
      const v = read();
      root.querySelectorAll('[data-fitment] .b-card').forEach((card) => {
        card.querySelector(':scope > .b-card__body > .fit')?.remove();
        card.classList.remove('is-nofit');
        const result = fits(card.dataset.fitment, card.dataset.universal === 'true', v);
        if (result === null) return;
        const p = document.createElement('p');
        p.className = `fit ${result ? 'fit--yes' : 'fit--no'}`;
        const words = result ? window.BladeVehicle.text.fits : window.BladeVehicle.text.noFit;
        p.innerHTML = `${result ? YES : NO}<span>${esc(words)} ${esc(label(v))}</span>`;
        card.querySelector('.b-card__body')?.appendChild(p);
        if (!result) card.classList.add('is-nofit');
      });
    };

    window.BladeVehicle = { read, write, label, fits, parseEntry, paintCards, assumeUniversal: true, allUniversal: true, text: { fits: 'Fits your', noFit: 'Does not fit your' } };
    /* section scripts can run before this one; they wait for this event */
    document.dispatchEvent(new CustomEvent('blade:vehicle-ready'));

    const repaint = () => paintCards();
    document.addEventListener('blade:vehicle', repaint);
    document.addEventListener('blade:cards-rendered', repaint);
    window.addEventListener('storage', (e) => { if (e.key === KEY) document.dispatchEvent(new CustomEvent('blade:vehicle')); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', repaint); else repaint();

    if (customElements.get('blade-vehicle-drawer')) return;

    class BladeVehicleDrawer extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        /* the header is a sticky stacking context; the drawer moves to <body> so it
           always sits above the page, inside its own .blade host for the tokens */
        if (!this.closest('.blade-vehicle-host')) {
          const host = document.createElement('div');
          host.className = 'blade blade-vehicle-host';
          document.body.appendChild(host);
          host.appendChild(this);
          return;
        }
        this.ready = true;
        loadCatalogue();
        this.panel = this.querySelector('.vdr');
        this.scrim = this.querySelector('[data-veh-scrim]');
        const d = this.panel.dataset;
        this.steps = d.steps.split('|');
        this.popular = d.popular.split(',').map((s) => s.trim()).filter((m) => catalogue[m]);
        window.BladeVehicle.text = { fits: this.getAttribute('data-fits') || 'Fits your', noFit: this.getAttribute('data-no-fit') || 'Does not fit your' };
        window.BladeVehicle.assumeUniversal = this.getAttribute('data-assume-fit') === 'true';
        window.BladeVehicle.allUniversal = this.getAttribute('data-all-fit') === 'true';
        const years = [];
        for (let y = new Date().getFullYear() + 1; y >= 1990; y--) years.push(String(y));
        this.years = years;
        this.draft = {};
        this.step = 0;

        document.addEventListener('click', (e) => {
          const opener = e.target.closest('[data-veh-open]');
          if (opener) { e.preventDefault(); this.open(opener); }
        });
        this.addEventListener('click', (e) => this.onClick(e));
        this.querySelector('[data-veh-search]').addEventListener('input', () => this.paintList());
        this.panel.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
        this.scrim.addEventListener('click', () => this.close());
        document.addEventListener('blade:vehicle', () => this.renderSaved());
        paintCards();
      }

      open(opener) {
        this.opener = opener;
        this.panel.classList.add('is-open');
        this.scrim.classList.add('is-open');
        this.panel.setAttribute('aria-hidden', 'false');
        document.documentElement.setAttribute('scroll-lock', '');
        if (read()) this.showMethod(); else this.showList(0);
        requestAnimationFrame(() => this.panel.querySelector('[data-veh-search]:not([hidden]), .vopt, .vrow')?.focus({ preventScroll: true }));
      }

      close() {
        if (!this.panel.classList.contains('is-open')) return;
        this.panel.classList.remove('is-open');
        this.scrim.classList.remove('is-open');
        this.panel.setAttribute('aria-hidden', 'true');
        document.documentElement.removeAttribute('scroll-lock');
        this.opener?.focus?.({ preventScroll: true });
      }

      $(sel) { return this.querySelector(sel); }

      showMethod() {
        this.draft = {}; this.step = 0;
        this.$('[data-veh-method]').hidden = false;
        this.$('[data-veh-list-pane]').hidden = true;
        this.$('[data-veh-foot]').hidden = true;
        this.$('[data-veh-back]').hidden = true;
        this.$('[data-veh-title]').textContent = this.panel.dataset.title;
        this.renderSaved();
      }

      renderSaved() {
        const v = read();
        const box = this.$('[data-veh-saved]');
        box.hidden = !v;
        if (!v) return;
        const d = this.panel.dataset;
        box.innerHTML = `<b>${esc(label(v))}</b><p>${esc(d.savedLabel)}</p><button type="button" data-veh="change">${esc(d.change)}</button><button type="button" data-veh="clear">${esc(d.remove)}</button>`;
      }

      showList(i) {
        this.step = i;
        this.$('[data-veh-method]').hidden = true;
        this.$('[data-veh-list-pane]').hidden = false;
        this.$('[data-veh-back]').hidden = false;
        this.$('[data-veh-title]').textContent = `${this.panel.dataset.choose} ${this.steps[i]}`;
        this.$('[data-veh-search]').value = '';
        this.querySelectorAll('.vtab').forEach((t, n) => {
          t.classList.toggle('is-on', n === i);
          t.classList.toggle('is-done', n < i);
          t.disabled = (n === 1 && !this.draft.year) || (n === 2 && !this.draft.make);
        });
        const parts = [this.draft.year, this.draft.make, this.draft.model].filter(Boolean);
        this.$('[data-veh-chosen]').innerHTML = parts.length ? `${this.$('.vopt__ic').innerHTML}<span>${esc(parts.join(' '))}</span>` : '';
        this.paintList();
        this.paintFoot();
        this.$('.vdr__scroll').scrollTop = 0;
      }

      options() {
        if (this.step === 0) return { all: this.years };
        if (this.step === 1) return { popular: this.popular, all: makes().slice().sort() };
        return { all: (catalogue[this.draft.make] || []).slice() };
      }

      paintList() {
        const q = this.$('[data-veh-search]').value.trim().toLowerCase();
        const o = this.options();
        const chosen = [this.draft.year, this.draft.make, this.draft.model][this.step];
        const rows = (list) => list.filter((v) => !q || v.toLowerCase().includes(q))
          .map((v) => `<button class="vrow${v === chosen ? ' is-on' : ''}" type="button" data-v="${esc(v)}">${esc(v)}</button>`).join('');
        let html = '';
        const all = rows(o.all);
        if (o.popular && !q) html += `<p class="vdr__h">${esc(this.panel.dataset.popularLabel)}</p>${rows(o.popular)}<p class="vdr__h">${esc(this.panel.dataset.allLabel)}</p>`;
        html += all;
        this.$('[data-veh-list]').innerHTML = all ? html : `<p class="vdr__empty">${esc(this.panel.dataset.empty)}</p>`;
      }

      paintFoot() {
        const ready = !!this.draft.model;
        this.$('[data-veh-foot]').hidden = !ready;
        if (ready) this.$('[data-veh-preview]').textContent = label(this.draft);
      }

      onClick(e) {
        if (e.target.closest('[data-veh-ymm]')) return this.showList(0);
        const row = e.target.closest('.vrow');
        if (row) {
          const v = row.dataset.v;
          if (this.step === 0) { this.draft = { year: v }; this.showList(1); }
          else if (this.step === 1) { this.draft = { year: this.draft.year, make: v }; this.showList(2); }
          else { this.draft.model = v; this.paintList(); this.paintFoot(); }
          return;
        }
        const tab = e.target.closest('.vtab');
        if (tab && !tab.disabled) return this.showList(+tab.dataset.step);
        const saved = e.target.closest('[data-veh]');
        if (saved) {
          if (saved.dataset.veh === 'clear') write(null); else this.showList(0);
          return;
        }
        if (e.target.closest('[data-veh-close]')) return this.close();
        if (e.target.closest('[data-veh-back]')) {
          if (this.step > 0) this.showList(this.step - 1);
          else if (read()) this.showMethod();
          else this.close();
          return;
        }
        if (e.target.closest('[data-veh-add]')) {
          write({ year: this.draft.year, make: this.draft.make, model: this.draft.model });
          this.close();
        }
      }
    }
    customElements.define('blade-vehicle-drawer', BladeVehicleDrawer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blade2-card-styles"] && !Shopify.designMode) return;
  try {
    /* Add to cart from a card, through the theme's own cart so the drawer and
     the counts behave exactly as they already do. */
  if (!window.__blade2Add) {
    window.__blade2Add = true;
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-b2-add]');
      if (!button) return;
      event.preventDefault();
      const id = button.getAttribute('data-b2-add');
      button.disabled = true;
      try {
        if (window.bladeCartAdd) {
          await window.bladeCartAdd(id, 1);
        } else {
          await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
          });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      } finally {
        button.disabled = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
